import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';

export default createMemoStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  SocialProof: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: type.fontSize.bodySm,
    margin: [spacing[2], spacing[3]],
    paddingBottom: spacing[2],
    fontWeight: type.fontWeight.medium,
    borderBottom: `1px solid ${pricingPalette.colors.flint}`,
    color: pricingPalette.colors.slate,
    [MD_MEDIA_QUERY]: {
      flexWrap: 'nowrap',
    },

    '& > *': {
      height: 15,
      padding: [spacing[3], spacing[3]],
      [MD_MEDIA_QUERY]: {
        flex: '0 1 auto',
      },
    },

    '& .trusted-text': {
      flex: '0 1 100%',
      textAlign: 'center',
      [MD_MEDIA_QUERY]: {
        flex: '0 1 auto',
      },
    },

    '& .shopify-logo': {
      flex: '0 1 10%',
      height: 20,
      objectFit: 'contain',
      [MD_MEDIA_QUERY]: {
        flex: '0 1 auto',
      },
    },

    '& .chewy-logo': {
      flex: '0 1 10%',
      padding: [spacing[4], spacing[3], spacing[3]],
      objectFit: 'contain',
      [MD_MEDIA_QUERY]: {
        flex: '0 1 auto',
      },
    },

    '& .adidas-logo': {
      flex: '0 1 10%',
      objectFit: 'contain',
      [MD_MEDIA_QUERY]: {
        flex: '0 1 auto',
      },
    },

    '& .jpm-logo, .jhu-logo': {
      flex: '0 1 30%',
      objectFit: 'contain',
      [MD_MEDIA_QUERY]: {
        flex: '0 1 auto',
      },
    },
  },
}));
